<template>
  <Navigation :title="$t('paymentCheckout.title')" />

  <div class="vh-100 d-flex justify-content-center flex-column align-items-center px-3">
    <div class="icon-container"><i class="bi bi-bookmark-fill"></i></div>
    <h2 class="text-center mt-4">{{ $t('paymentCheckout.saved') }}</h2>
    <p class="lead text-center mt-3 mb-4">{{ $t('paymentCheckout.clickToPayment') }}</p>
    <a :href="this.checkoutData.payment_url" class="btn btn-primary btn-lg" target="_blank" rel="noreferer noopener">{{ $t('paymentCheckout.processPayment') }}</a>
  </div>
</template>

<script>
import Navigation from "../components/Navigation";

export default {
  name: "PaymentCheckout",
  components: { Navigation },
  mounted() {
    this.checkoutData = this.$store.getters.getCheckout
  },
  data() {
    return {
      checkoutData: [],
    };
  },
};
</script>

<style scoped>
.icon-container {
  font-size: 3rem;
  margin-top: 20px;
}
</style>
